module.exports = __webpack_public_path__ + "assets/img/118@3x.0571b2f8.png";